<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import Tools from "./scripts/tools.js";
import Global from "./scripts/Global.js";

Tools.rem.useRem(750, 50);

Object.keys(Global.audio_intor).forEach(audioKey => {
  Global.audio_intor[audioKey].load();
});

const BODY = document.querySelector("body");

function AUDIO_INIT(e) {
  BODY.removeEventListener("click", AUDIO_INIT);
  Global.startBgm();
  Object.keys(Global.audio_intor).forEach(audioKey => {
    const audioDom = Global.audio_intor[audioKey];
    audioDom.play();
    audioDom.pause();
  });
}

BODY.addEventListener("click", AUDIO_INIT);
function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
window.channel = getQueryVariable("channel");
window.channel = window.channel
  ? window.channel.replace(/\//gi, "")
  : undefined;

window.setShare({
  title: "连麦吗？我男神音。",
  desc: "和四大声优云游御花园，答题抽限量明星签名周边",
  link: location.href.split("#")[0],
  imgUrl: "https://cdn.original-fun.com/gugong/icon120.jpg"
});

export default {
  name: "app"
};
</script>
<style>
html {
  font-size: 100px;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 16px;
  margin: auto;
  max-width: 750px;
  position: relative;
  overflow: hidden;
}
.inner-rel-box {
  position: absolute;
  width: 100%;
  height: 100%;
}

.mask05 {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.5);
}

.mask00 {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
}

.question {
  z-index: 10;
}

.sharetip {
  position: absolute;
  width: 100%;
  height: 100%;

  z-index: 1;
  background-color: rgba(255, 255, 255, 0.8);
}

.sharetip .s {
  background-image: url(//cdn.original-fun.com/gugong/分享指引.png);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  width: 4rem;
  height: 2rem;
  background-size: contain;
  right: 0;
  z-index: 20;
}
</style>
